exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".body-item[data-v-ac50c77a]{overflow:hidden;position:relative;margin-top:15px}.body-title[data-v-ac50c77a]{background:#31aaff;padding:6px;position:absolute;color:#fff;margin-left:15px}.body-content[data-v-ac50c77a]{line-height:30px;font-size:15px;min-height:70px;border:1px solid #ddd;border-radius:5px;margin-top:15px;padding-top:27px;padding-left:15px;padding-bottom:19px}.product-buyer-name[data-v-ac50c77a]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-ac50c77a","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/electronicMedicalRecord/patient/parts/road/index.vue
// module id = GCcZ
// module chunks = 0